<app-user-group-icon (click)="openModal()"/>

@if (groupVoucher().groupVoucher) {
  <span (click)="openModal()" class="voucher">
    {{ groupVoucher().groupVoucher?.code }}
  </span>
}
<p (click)="openModal()" class="hide-content-mobile mt-1 mb-0">Gruppekøb</p>
